export default {
    GET_REQUEST: 'FILE_GET_REQUEST',
    GET_SUCCESS: 'FILE_GET_SUCCESS',
    GET_FAILURE: 'FILE_GET_FAILURE',
    CREATE_REQUEST: 'FILE_CREATE_REQUEST',
    CREATE_SUCCESS: 'FILE_CREATE_SUCCESS',
    CREATE_FAILURE: 'FILE_CREATE_FAILURE',
  };
  